// Layered cross-section of the Speedy Resurfacing system per finish (VersaCourt-style system diagram).
const SYSTEMS = {
  "Acrylic Hard Court": [
    ["Line Marking", "#F2F2F2", "Precision-taped 2-coat game lines"],
    ["Acrylic Colour ×2", "#2E6FB0", "UV-stable textured colour coats"],
    ["Acrylic Resurfacer", "#5B6670", "Fills and levels the surface profile"],
    ["Crack Repair + Prep", "#3F3F44", "Cracks routed, filled, pressure cleaned"],
    ["Existing Slab", "#26262A", "Your concrete or asphalt base"],
  ],
  "Cushioned Acrylic": [
    ["Line Marking", "#F2F2F2", "Precision-taped 2-coat game lines"],
    ["Acrylic Colour ×2", "#2E6FB0", "UV-stable textured colour coats"],
    ["Cushion Layers ×3", "#B5502E", "Rubberised shock-absorbing comfort layers"],
    ["Acrylic Resurfacer", "#5B6670", "Fills and levels the surface profile"],
    ["Crack Repair + Prep", "#3F3F44", "Cracks routed, filled, pressure cleaned"],
    ["Existing Slab", "#26262A", "Your concrete or asphalt base"],
  ],
  "Premium Tile System": [
    ["Game Lines", "#F2F2F2", "Painted or inlaid tile line system"],
    ["Modular Sport Tile", "#2E6FB0", "Interlocking, self-draining performance tiles"],
    ["Levelling + Prep", "#3F3F44", "Base corrected for a true, flat playing field"],
    ["Existing Slab", "#26262A", "Your concrete or asphalt base"],
  ],
};

export default function ResurfacingSystem({ finish }) {
  const layers = SYSTEMS[finish] || SYSTEMS["Acrylic Hard Court"];
  return (
    <div className="rounded-sm border border-white/10 bg-obsidian-800/60 p-5" data-testid="resurfacing-system">
      <p className="font-mono text-[10px] uppercase tracking-widest text-gold mb-4">The Speedy Resurfacing System · {finish}</p>
      <div className="space-y-2">
        {layers.map(([name, colour, desc], i) => (
          <div key={name} className="flex items-center gap-4" data-testid={`system-layer-${i}`}>
            <div className="shrink-0 h-4 rounded-[2px]"
              style={{ width: `${72 + i * 12}px`, backgroundColor: colour, transform: "skewX(-24deg)", boxShadow: "0 6px 16px rgba(0,0,0,0.5)" }} />
            <div className="min-w-0">
              <p className="text-sm font-bold leading-tight text-white">{name}</p>
              <p className="text-xs text-zinc-500 truncate">{desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
